import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Services from '../components/Services';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { ArrowRight } from 'lucide-react';

const ITServicesPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-950">
      <Header />
      <div className="pt-20">
        <Services />
        {/* CTA */}
        <section className="py-20 bg-slate-950">
          <div className="max-w-3xl mx-auto px-6 text-center">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">Need IT Help?</h2>
            <p className="text-slate-400 text-lg mb-8">
              From network setup to computer repair — we're here to help. Contact us for a free consultation.
            </p>
            <Button
              onClick={() => navigate('/contact')}
              size="lg"
              className="bg-cyan-500 hover:bg-cyan-600 text-white px-8 py-6 text-lg font-semibold shadow-xl shadow-cyan-500/30 group"
            >
              Contact Us <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default ITServicesPage;
